<template>
  <div class="bk-content">
    <!-- [{ width: windowWidth + 'px' }, { height: windowHeight + 'px' }] -->
    <iframe
      style="width: 100%; height: 100%"
      allowfullscreen="true"
      frameborder="no"
      :src="iframeUrl + '&t=' + Math.random()"
    ></iframe>
  </div>
</template>
<script>
import { beikeHost } from "@/utils/apis";
import { mapState } from "vuex";
export default {
  data() {
    return {
      windowWidth: 0,
      windowHeight: 0,
      iframeUrl: "",
    };
  },
  watch: {
    currentCourse: {
      handler(newval, oldVal) {
        if (newval && !oldVal) {
          let { from, nav, tab } = this.$route.query;
          newval = JSON.parse(JSON.stringify(newval));
          this.iframeUrl = `https://${beikeHost}/index.html#/?mode=wxt&appId=155001b9004e452a${
            from == "bk" ? "" : "&courseId=" + newval.courseId
          }${nav ? "&nav=" + nav : ""}${tab ? "&tab=" + tab : ""}`;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    console.log("mounted");
    this.initInframeUrl();
    this.initWidth();
  },
  computed: {
    ...mapState(["currentCourse"]),
  },
  methods: {
    initWidth() {
      this.windowWidth = window.innerWidth - 76;
      this.windowHeight = window.innerHeight - 62;
    },
    initInframeUrl() {
      let { courseId, from, nav, tab } = this.$route.query;
      if (courseId) {
        this.iframeUrl = `https://${beikeHost}/index.html#/?mode=wxt&appId=155001b9004e452a${
          from == "bk" ? "" : "&courseId=" + courseId
        }${nav ? "&nav=" + nav : ""}${tab ? "&tab=" + tab : ""}`;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.bk-content {
  height: 100%;
  overflow-y: hidden;
}
</style>
